import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
  palette: {},
  titles: {
    fontFamily: `'Jost', sans-serif`,
  },
  typography: {
    fontFamily: `calibri, sans-serif`,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
  },
});

export const colors = {
  // Text
  TEXT_PRIMARY: "#231f20",
  TEXT_SECONDARY: "#ababab",
  LINK: "#16b2ad",
  LINK_HOVER: "#f6c221",
  URL: "#00b5ae",

  // General
  BACKGROUND_PRIMARY: "#ffffff",
  BACKGROUND_SECONDARY: "#fafafa",
  BANNER_TEXT: "#ffffff",
  JOIN_DISCUSSION_TEXT: "#ffffff",
  JOIN_DISCUSSION_BG: "#16b2ad",
  SLOGAN_TEXT: "#ffffff",
  SPINNER: "#ffffff",
  BORDER: "#f0f0f0",
  LANGUAGE_ACTIVE: "#16b2ad",
  LANGUAGE_INACTIVE: "#bebebe",

  // Buttons
  BUTTON_BG: "#005dbd",
  BUTTON_TEXT: "#ffffff",

  // FAQ
  FAQ_EXPAND_ICON: "#16b2ad",
  FAQ_ANSWER_BG: "#f8f6f6",

  // Statements
  STATEMENT_TITLE: "#ffffff",
  FOLLOW_ICON: "#c64344",
  FOLLOW_BUTTON_BG: "#ffffff",
  FOLLOW_BUTTON_TEXT: "231f20",
  VOTE_SWIPE_HINT: "#ffffff",
  STATEMENT_NAV_BG: "#231f20",
  STATEMENT_NAV_BUTTON_TEXT: "#ffffff",
  VOTE_NO_OPINION_BG: "#ffffff",
  VOTE_NO_OPINION_TEXT: "#231f20",
  AGREED: "#3b9f6f",
  DISAGREE: "#c34843",

  // Comments
  LIKED: "#459a5f",
  COMMENT_BORDER: "#CCC",

  // Avatar
  AVATAR_LETTER_BG: "#16b2ad",
  AVATAR_LETTER_TEXT: "#ffffff",

  // Menu
  MENU_ITEM: "#231f20",
  MENU_ITEM_ACTIVE: "#16b2ad",
  MENU_CLOSE_ICON: "#ffffff",
  SIGN_IN_BUTTON_BG: "#ffffff",
  SIGN_IN_BUTTON_TEXT: "#231f20",
  MENU_PROFILE_LINK: "#ffffff",

  // Forms
  CHECKBOX: "#16b2ad",
  ERROR: "#c64344",

  // Cookie
  COOKIE_BG: "#f1bf26",
  COOKIE_BTN: "#005dbd",
  COOKIE_BTN_HOVER: "#2384e8",
};

export default theme;
